import { defineComponent, type ReactiveComponent } from "vue-utils"

const UniformBenefits: ReactiveComponent = () => {
	return () => <></>
}

export default defineComponent(UniformBenefits)
